import React from "react";
import "../Styles/Loader.css"; 
const Loader = () => {
    return (
        <div className="loader-overlay">
            <div className="loader"></div>
        </div>
    );
};

export default Loader;
